import React from "react";

/**
 * Базовая карточка DS (canon-session 2026-07-24, направление «Приборная»).
 * Мягкая приподнятость + чёткая грань: крупный радиус, тонкая рамка,
 * БЕЗ тени на статичных карточках (тень — только у плавающих Dialog/Toast).
 */
/**
 * `forwardRef` — чтобы вызывающий мог наблюдать за карточкой, не оборачивая её
 * лишним div'ом: карточки стоят прямыми детьми grid-раскладок, и обёртка сломала
 * бы сетку. Понадобилось для отложенного монтажа графиков (`useNearViewport`).
 */
export const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement> & {
  /** приподнятая поверхность (bg-bg-elevated вместо bg-bg-card) */
  elevated?: boolean;
  /**
   * "indigo" — bespoke индиго-поверхность (bg var(--indigo-card-bg), top-hairline, shadow)
   * через существующий CSS-класс `.indigo-card`. Пиксель-в-пиксель замена
   * инлайновых `<div className="indigo-card">`, чтобы вид не менялся при
   * миграции на DS. "default" — плоская DS-карточка (border + rounded-ring).
   */
  variant?: "default" | "indigo";
  /** внутренний отступ в px (default 16) */
  padding?: number;
}>(function Card({
  elevated = false,
  variant = "default",
  padding = 16,
  className = "",
  children,
  style,
  ...rest
}, ref) {
  const surface =
    variant === "indigo"
      ? "indigo-card"
      : `${elevated ? "bg-bg-elevated" : "bg-bg-card"} border border-border rounded-ring`;
  return (
    <div
      {...rest}
      ref={ref}
      style={{ padding, ...style }}
      className={`${surface} ${className}`}
    >
      {children}
    </div>
  );
});
